import { Checkbox, csx, useCheckboxState } from '@vtex/admin-ui'
import { useWatch } from '@vtex/admin-ui-form'
import { useIntl } from 'react-intl'

import type { Recurrence as RecurrenceType } from 'typings'
import { useFormStateContext } from '../../../providers'
import { TimeIntervals } from './TimeIntervals'
import { Weekdays } from './Weekdays'

import { messages } from './messages'

type Props = {
  name: string
}

export function Recurrence(props: Props) {
  const { name } = props
  const { formatMessage } = useIntl()
  const { form } = useFormStateContext()
  const recurrence: RecurrenceType | undefined = useWatch({
    form,
    name,
  })

  const enabled =
    Boolean(recurrence?.weekdays?.length) ||
    Boolean(recurrence?.timeIntervals?.length)

  const checkboxState = useCheckboxState({ initialValue: enabled })

  const handleEnablerChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const enabled = event.target.checked
    if (enabled) {
      form.setValue(name, { weekdays: [], timeIntervals: [] })
    } else {
      form.setValue(name, undefined)
      form.clearErrors(name)
    }
  }

  return (
    <div className={csx({ paddingTop: '$space-3' })}>
      <Checkbox
        label={formatMessage(messages.recurrenceSettingsEnabler)}
        state={checkboxState}
        onChange={handleEnablerChange}
      />

      {checkboxState.value && (
        <div className={csx({ marginLeft: '$space-7' })}>
          <Weekdays name={`${name}.weekdays`} />
          <TimeIntervals name={`${name}.timeIntervals`} />
        </div>
      )}
    </div>
  )
}
